jQuery('#header-part a.mobilemenu').off('click').on('click', function(e) {

    e.preventDefault();

    jQuery(this).toggleClass('active');

    jQuery('#header-part .menubg').slideToggle();

	jQuery('#wrapper').toggleClass('showhead');

});



jQuery('#header-part a.close').click(function(e) {

    e.preventDefault();

	jQuery(this).removeClass('active');

	jQuery('#header-part .menubg').removeClass('showmenu');

});



jQuery('#header-part .menu_sec li.menu-item-has-children > span.submenuarrow').click(function(e) {

    e.preventDefault();

	jQuery(this).toggleClass('active');

	jQuery(this).parent().toggleClass('selected');

	jQuery(this).next().slideToggle();

});

if (jQuery(window).width() < 1024){
  jQuery('#header-part .menubg ul.menu li li.deeplink').on('click', 'a', function(e) {
    jQuery('#header-part .menubg').slideUp();
    jQuery('a.mobilemenu').removeClass('active');
  });
}

jQuery(window).bind('scroll load', function() {
      var navHeight = jQuery("#header-part").height();
     
		(jQuery(window).scrollTop() > navHeight) ? jQuery('#header-part').addClass('show') : jQuery('#header-part').removeClass('show');
		
		(jQuery(window).scrollTop() > navHeight) ? jQuery('.topprogressbar').addClass('visibles') : jQuery('.topprogressbar').removeClass('visibles');
		(jQuery(window).scrollTop() > navHeight) ? jQuery('#content-part .blog-bar #scroll-line').addClass('visibles') : jQuery('#content-part .blog-bar #scroll-line').removeClass('visibles');
    });